export default __webpack_public_path__ + "static/media/aquarium02_04.02d82802.png";